__turbopack_context__.v({
  "button": "BlogTOC-module-scss-module__M7pWDW__button",
  "buttonActive": "BlogTOC-module-scss-module__M7pWDW__buttonActive",
  "enter": "BlogTOC-module-scss-module__M7pWDW__enter",
  "exit": "BlogTOC-module-scss-module__M7pWDW__exit",
  "fade-in": "BlogTOC-module-scss-module__M7pWDW__fade-in",
  "fade-out": "BlogTOC-module-scss-module__M7pWDW__fade-out",
  "fade-out-80": "BlogTOC-module-scss-module__M7pWDW__fade-out-80",
  "label": "BlogTOC-module-scss-module__M7pWDW__label",
  "nav": "BlogTOC-module-scss-module__M7pWDW__nav",
  "slide-in-from-bottom": "BlogTOC-module-scss-module__M7pWDW__slide-in-from-bottom",
  "slide-in-from-left": "BlogTOC-module-scss-module__M7pWDW__slide-in-from-left",
  "slide-in-from-right": "BlogTOC-module-scss-module__M7pWDW__slide-in-from-right",
  "slide-in-from-top": "BlogTOC-module-scss-module__M7pWDW__slide-in-from-top",
  "slide-out-to-bottom": "BlogTOC-module-scss-module__M7pWDW__slide-out-to-bottom",
  "slide-out-to-left": "BlogTOC-module-scss-module__M7pWDW__slide-out-to-left",
  "slide-out-to-right": "BlogTOC-module-scss-module__M7pWDW__slide-out-to-right",
  "slide-out-to-top": "BlogTOC-module-scss-module__M7pWDW__slide-out-to-top",
  "zoom-in": "BlogTOC-module-scss-module__M7pWDW__zoom-in",
  "zoom-out": "BlogTOC-module-scss-module__M7pWDW__zoom-out",
});
